/**
 * ابزارهای بالینی (ZOY-599) — فقط رابط. همهٔ متن بالینی (نام ابزار، گویه‌ها،
 * برچسب گزینه‌ها، نام مقیاس‌ها) از بستهٔ متنی پین‌شدهٔ همان اجرا می‌آید و
 * اینجا ترجمه نمی‌شود.
 */
export const instrumentsFa: Record<string, string> = {
  /* Record section */
  'inst.sectionTitle': 'ابزارهای بالینی',
  'inst.sectionSub':
    'پرسش‌نامه‌های استانداردشده‌ای که برای این مراجع اجرا و توسط سیستم امتیازدهی می‌شوند. مستقل از ارزیابی‌ها و جلسات.',
  'inst.start': 'اجرای ابزار',
  'inst.series': 'نتایج در طول زمان',
  'inst.emptyTitle': 'هنوز ابزاری اجرا نشده',
  'inst.emptyBody':
    'ابزار استانداردشده را مراقب یا خود مراجع پاسخ می‌دهد، کارکنان ثبت می‌کنند، و هنگام نهایی شدن بر اساس جدول‌های هنجاری اش امتیازدهی می‌شود.',
  'inst.emptyGate': 'اجرای ابزار به یک پرونده مراجع ثبت‌شده نیاز دارد.',
  'inst.drafts': '{n, number} پیش‌نویس در جریان',
  'inst.continue': 'ادامه',
  'inst.view': 'مشاهده',
  'inst.status.draft': 'پیش‌نویس',
  'inst.status.finalized': 'نهایی‌شده',
  'inst.status.superseded': 'جایگزین‌شده',
  'inst.respondent.caregiver': 'مراقب',
  'inst.respondent.patient': 'مراجع (خود)',
  'inst.respondent.other': 'سایر',
  'inst.age': '{y, number} سال{m, plural, =0 {} other { و # ماه}}',
  'inst.ageUnknown': 'سن نامشخص',
  'inst.tally.scored': '{n, number} امتیاز خورده',
  'inst.tally.rawOnly': '{n, number} فقط خام',
  'inst.tally.notScorable': '{n, number} قابل امتیازدهی نیست',
  'inst.startedLine': 'شروع‌شده {date} توسط {who}',
  'inst.finalizedLine': 'نهایی‌شده {date} توسط {who}',
  'inst.supersededLine': 'با یک اجرای اصلاحی جایگزین شد',
  'inst.correctsLine': 'اجرای قبلی را اصلاح می‌کند',

  /* Start page */
  'inst.newTitle': 'اجرای ابزار',
  'inst.newSub':
    'ابزار را انتخاب کنید، بگویید چه کسی پاسخ می‌دهد، و تاریخ را تنظیم کنید. کارمندی که ثبت می‌کند شما هستید — خودکار یادداشت می‌شود.',
  'inst.pickInstrument': 'ابزار',
  'inst.pickInstrumentHelp':
    'برای ادامه یکی انتخاب کنید. هر کارت نشان می‌دهد چه کسی گزارش می‌دهد، چه سن‌هایی را پوشش می‌دهد، و آیا جدول هنجاری دارد.',
  'inst.pickFirst': 'برای ادامه یک ابزار در بالا انتخاب کنید.',
  'inst.noInstruments': 'هنوز هیچ ابزاری برای این کلینیک در دسترس نیست.',
  'inst.catalogueFailed': 'فهرست ابزارها بارگذاری نشد.',
  'inst.selected': 'انتخاب‌شده',
  'inst.forAges': 'برای سنین {from} تا {to}',
  'inst.forAgesFrom': 'از سن {from}',
  'inst.forAgesTo': 'تا سن {to}',
  'inst.designedFor.caregiver': 'گزارش مراقب',
  'inst.designedFor.self': 'گزارش خود',
  'inst.designedFor.either': 'گزارش مراقب یا خود',
  'inst.norms': 'هنجارها: {list}',
  'inst.noNorms': 'بدون جدول هنجاری — فقط امتیازهای خام',
  'inst.detailsTitle': 'پاسخ‌دهنده و تاریخ',
  'inst.detailsSub':
    'چه کسی به پرسش‌ها پاسخ داد، و چه زمانی. ثبت‌کننده شما هستید و این‌جا پرسیده نمی‌شود.',
  'inst.respondentType': 'چه کسی پاسخ می‌دهد',
  'inst.respondentHelp': 'شخصی که پاسخ‌هایش ثبت می‌شود — نه کارمندی که تایپ می‌کند.',
  'inst.relationship': 'نسبت با مراجع',
  'inst.relationshipHelp': 'مثلا مادر، پدر، معلم.',
  'inst.administeredOn': 'تاریخ اجرا',
  'inst.administeredOnHelp': 'سن در این تاریخ جدول هنجاری را انتخاب می‌کند.',
  'inst.locale': 'زبان عبارت‌ها',
  'inst.localeHelp': 'زبانی که ابزار با آن ارائه می‌شود. برای این اجرا ثابت می‌شود.',
  'inst.localeName.en': 'انگلیسی',
  'inst.localeName.fa': 'فارسی',
  'inst.ageAtDate': 'سن در آن تاریخ: {age}',
  'inst.dobEstimated': 'تاریخ تولد تقریبی ثبت‌شده است.',
  'inst.warnAgeUnknownTitle': 'تاریخ تولدی در پرونده نیست',
  'inst.warnAgeUnknownBody':
    'سن هنگام اجرا محاسبه نمی‌شود، بنابراین طبقه‌بندی هنجاری در دسترس نخواهد بود. امتیازهای خام همچنان ثبت می‌شوند. می‌توانید ادامه دهید.',
  'inst.warnAgeRangeTitle': 'خارج از بازه سنی اعلام‌شده ابزار',
  'inst.warnAgeRangeBody':
    'این ابزار برای {range} طراحی شده؛ مراجع در تاریخ اجرا {age} خواهد بود. ممکن است طبقه‌بندی هنجاری اعمال نشود. می‌توانید ادامه دهید.',
  'inst.startCta': 'شروع اجرا',
  'inst.startNote':
    'پاسخ‌ها همان‌طور که می‌روید ذخیره می‌شوند. تا نهایی نکنید چیزی امتیاز نمی‌خورد.',
  'inst.err.notAvailable':
    'آن ابزار دیگر در زبان انتخاب‌شده برای شروع در دسترس نیست. فهرست به‌روز شد.',
  'inst.err.date': 'آن تاریخ قابل‌استفاده نبود.',

  /* Administration page */
  'inst.versionChip': 'نسخه {n}',
  'inst.wordingChip': 'عبارت‌های {lang}',
  'inst.viewOnly': 'فقط‌خواندنی',
  'inst.recorder': 'ثبت‌شده توسط',
  'inst.factRespondent': 'پاسخ‌دهنده',
  'inst.factDate': 'اجرا شده',
  'inst.factAge': 'سن هنگام اجرا',
  'inst.saveDetails': 'ذخیره جزئیات',
  'inst.detailsSaved': 'جزئیات ذخیره شد.',
  'inst.unsupportedTitle': 'این ابزار این‌جا نمایش داده نمی‌شود',
  'inst.unsupportedBody':
    'از قالب تعریف جدیدتری از آنچه این نسخه برنامه می‌فهمد استفاده می‌کند. هیچ‌چیز درباره پاسخ‌ها از بین نمی‌رود یا عوض نمی‌شود — نمایشش به برنامه به‌روز شده نیاز دارد.',
  'inst.answeredOf': '{answered} از {total} پاسخ داده شده',
  'inst.openCount': '{n} بی‌پاسخ',
  'inst.allAnswered': 'همه گویه‌ها پاسخ داده‌شده',
  'inst.na': 'قابل اعمال نیست',
  'inst.naHint':
    'گویه‌ای که «قابل اعمال نیست» علامت بخورد، هر مقیاسی که به آن تعلق دارد را بدون امتیاز می‌گذارد.',
  'inst.clear': 'پاک کردن پاسخ',
  'inst.note': 'یادداشت',
  'inst.addNote': 'افزودن یادداشت',
  'inst.noAnswer': 'پاسخ داده نشده',
  'inst.sectionComment': 'نظر بخش',
  'inst.overallComment': 'نظر کلی',
  'inst.commentsTitle': 'نظرها',
  'inst.commentsSub': 'ملاحظات کیفی بخشی از ابزارند و با آن ذخیره می‌شوند.',
  'inst.saving': 'در حال ذخیره…',
  'inst.saved': 'ذخیره شد',
  'inst.saveFailed': 'ذخیره نشد — ورودی‌های شما این‌جا نگه داشته می‌شوند.',
  'inst.retry': 'تلاش دوباره',
  'inst.saveStale':
    'این پیش‌نویس دیگر زنده نیست — جای دیگری نهایی یا جایگزین شد. دوباره بازش کنید تا وضعیت فعلی را ببینید.',
  'inst.saveRejected':
    'یک پاسخ پذیرفته نشد، بنابراین آن تغییر ذخیره نشد. هر چه روی صفحه است نگه داشته می‌شود — تنظیمش کنید و دوباره ذخیره می‌شود.',
  'inst.saveForbidden': 'مجوز شما برای ثبت این اجرا تمام‌شده. چیزی ذخیره نشد.',
  'inst.finalize': 'نهایی‌کردن',
  'inst.finalizeTitle': 'این اجرا نهایی شود؟',
  'inst.finalizeBody':
    'امتیازها بر اساس جدول هنجاری ثابت شده محاسبه می‌شوند و پرونده فقط‌خواندنی می‌شود.',
  'inst.finalizeUnanswered':
    '{n, number} گویه بی‌پاسخ است. نهایی‌سازی همچنان معتبر است: مقیاس‌های دربرگیرندهٔ آن گویه‌ها «غیرقابل نمره‌گذاری» گزارش می‌شوند — هرگز صفر.',
  'inst.finalizeEffectTitle': 'این کار چه می‌کند',
  'inst.finalizeEffect':
    'پاسخ‌ها و نظرها منجمد می‌شوند. اصلاح بعدی با جایگزین کردن انجام می‌شود — این پرونده به‌عنوان نهایی‌شده قابل مشاهده می‌ماند.',
  'inst.finalizeCta': 'نهایی‌کردن',
  'inst.finalizeFlushFailed':
    'نهایی‌کردن متوقف شد: آخرین پاسخ‌ها ذخیره نشدند. هیچ‌چیز از آنچه وارد کردید از بین نرفت — ذخیره را دوباره امتحان کنید، بعد دوباره نهایی کنید.',
  'inst.finalizedSub':
    'دقیقا همان‌طور که نهایی شد نشان داده می‌شود — پاسخ‌ها، عبارت‌ها و نتایج منجمد شده‌اند.',
  'inst.supersededTitle': 'این اجرا جایگزین شد',
  'inst.supersededBody':
    'یک اجرای اصلاحی در {date} جایگزینش شد. این پرونده همان‌طور که نهایی شد خواندنی می‌ماند.',
  'inst.openSuperseding': 'باز کردن اجرای اصلاحی',
  'inst.correctsTitle': 'این اجرا اجرای قبلی را اصلاح می‌کند',
  'inst.correctsBody': 'نسخه اصلی روی پرونده می‌ماند، به‌عنوان جایگزین‌شده علامت‌خورده.',
  'inst.openOriginal': 'باز کردن نسخه اصلی',
  'inst.correct': 'اصلاح با جایگزین کردن',
  'inst.correctTitle': 'این اجرا اصلاح شود؟',
  'inst.correctBody':
    'از این یکی یک پیش‌نویس جدید ساخته می‌شود — همان پاسخ‌ها، پاسخ‌دهنده و تاریخ — تا اصلاحش کنید و دوباره نهایی کنید.',
  'inst.correctEffect':
    'این اجرای نهایی‌شده عوض یا حذف نمی‌شود: روی پرونده می‌ماند، به‌عنوان جایگزین‌شده علامت‌خورده، با نتایجش.',
  'inst.correctReason': 'دلیل اصلاح',
  'inst.correctReasonHelp': 'الزامی. با پرونده نگه داشته می‌شود.',
  'inst.correctCta': 'ساختن پیش‌نویس اصلاحی',
  'inst.err.notDraft':
    'این اجرا دیگر پیش‌نویس نیست — جای دیگری نهایی یا جایگزین شد. صفحه به‌روز شد.',
  'inst.err.notFinalized': 'فقط اجرای نهایی‌شده قابل‌اصلاح است.',
  'inst.err.alreadySuperseded': 'این اجرا از قبل اصلاح‌شده. اجرای اصلاحی را از پرونده باز کنید.',
  'inst.err.notFound': 'این اجرا پیدا نشد.',
  'inst.err.forbidden': 'مجوز شما برای این اقدام تمام‌شده.',
  'inst.err.commentNotAllowed': 'این نسخه ابزار این نوع نظر را نمی‌پذیرد.',

  /* Results */
  'inst.resultsTitle': 'نتایج',
  'inst.resultsSub':
    'هر مقیاس دقیقا یک نتیجه گزارش می‌دهد. امتیاز غایب به‌عنوان غایب نشان داده می‌شود — هیچ‌وقت صفر یا یک بازه معمول.',
  'inst.outcome.scored': 'امتیاز خورده',
  'inst.outcome.raw_only': 'فقط امتیاز خام',
  'inst.outcome.not_scorable': 'قابل امتیازدهی نیست',
  'inst.rawOf': 'از {max}',
  'inst.noClassification': 'بدون طبقه‌بندی هنجاری',
  'inst.noScore': 'بدون امتیاز',
  'inst.reason.missing_items': 'گویه‌های بی‌پاسخ',
  'inst.reason.not_applicable_items': 'گویه‌هایی که «قابل اعمال نیست» علامت‌خورده‌اند',
  'inst.reason.no_norm_set': 'هیچ جدول هنجاری برای این پاسخ‌دهنده و این سن اعمال نمی‌شود',
  'inst.reason.age_unknown': 'سن هنگام اجرا نامشخص است، بنابراین هیچ هنجار سنی اعمال نمی‌شود',
  'inst.reason.classification_unavailable': 'جدول هنجاری برای این امتیاز بازه‌ای ندارد',
  'inst.reason.sex_unknown': 'جنسیت مراجع ثبت‌نشده، بنابراین هیچ جدول هنجار جنسیتی اعمال نمی‌شود',
  'inst.standardScore.T': 'T-score {n}',
  'inst.standardScore.other': '{type} {n}',
  'inst.percentile': 'رتبه درصدی {n}',
  'inst.offendingItems': 'گویه‌ها',
  'inst.displayOnly': 'فقط گروه‌بندی — هیچ امتیازی تولید نمی‌کند',
  'inst.scaleType.section': 'بخش‌ها',
  'inst.scaleType.factor': 'عوامل',
  'inst.scaleType.quadrant': 'ربع‌ها',
  'inst.scaleType.total': 'جمع',
  'inst.scaleType.sensory_section': 'بخش‌های حسی',
  'inst.scaleType.behavioral_section': 'بخش‌های رفتاری',
  'inst.scaleType.sensory_category': 'دسته‌های حسی',
  'inst.direction.typical': 'معمول',
  'inst.direction.more_than_others': 'بیشتر از دیگران',
  'inst.direction.less_than_others': 'کمتر از دیگران',
  'inst.basisTitle': 'مبنای هنجاری',
  'inst.basisSub':
    'طبقه‌بندی‌ها فقط نسبت به همین جمعیت هستند. زبان عبارت‌ها هیچ‌وقت جمعیت هنجار را القا نمی‌کند.',
  'inst.basisNone': 'هیچ مبنای هنجاری در دسترس نبود — فقط امتیازهای خام.',
  'inst.basisPopulation': 'جمعیت',
  'inst.basisAges': 'بازه سنی',
  'inst.basisRespondent': 'پاسخ‌دهنده',
  'inst.basisModel': 'مدل طبقه‌بندی',
  'inst.basisSample': 'اندازه نمونه',
  'inst.basisSource': 'منبع',
  'inst.basisCompleteness': 'کامل بودن',
  'inst.normRespondent.caregiver': 'مراقب',
  'inst.normRespondent.self': 'خود',
  'inst.normRespondent.any': 'هر کدام',
  'inst.basisSex': 'جنسیت',
  'inst.normSex.male': 'پسران',
  'inst.normSex.female': 'دختران',
  'inst.normSex.any': 'هر کدام',
  'inst.answersTitle': 'پرسش‌نامه',
  'inst.qSub':
    'بخش به بخش پیش بروید. هر گویه همان‌طور که می‌روید ذخیره می‌شود؛ نوار کناری نشان می‌دهد در هر بخش چه چیزی مانده.',
  'inst.sectionsNav': 'بخش‌های پرسش‌نامه',
  'inst.sectionOf': 'بخش {n} از {total}',
  'inst.sectionDone': 'کامل',
  'inst.sectionLeft': '{n} مانده',
  'inst.sectionEmpty': 'شروع نشده',
  'inst.commentsStep': 'نظرها',
  'inst.prevSection': 'بخش قبلی',
  'inst.nextSection': 'بخش بعدی',
  'inst.toComments': 'رفتن به نظرها',
  'inst.nextUnanswered': 'بی‌پاسخ بعدی',
  'inst.progressLine': '{answered} از {total} پاسخ داده‌شده · {pct}%',
  'inst.readyToFinalize': 'همه گویه‌ها پاسخ داده‌شده — آماده نهایی‌کردن.',
  'inst.stillAllowed':
    'نهایی‌کردن همچنان مجاز است؛ گویه‌های بی‌پاسخ مقیاس‌هایشان را غیرقابل امتیازدهی می‌کنند.',
  'inst.backToRecord': 'بازگشت به پرونده مراجع',
  'inst.patientFile': 'پرونده {n}',
  'inst.patientLoading': 'در حال بارگذاری مراجع…',

  /* Series */
  'inst.seriesTitle': 'نتایج ابزار در طول زمان',
  'inst.seriesSub':
    'اجراهای نهایی‌شده، گروه‌بندی‌شده بر اساس آنچه قابل مقایسه است: یک ابزار، یک گروه نسخه، یک جدول هنجاری.',
  'inst.seriesEmpty': 'هنوز اجرای نهایی‌شده‌ای نیست — سری با اولین اجرای نهایی‌شده شروع می‌شود.',
  'inst.seriesFailed': 'سری بارگذاری نشد.',
  'inst.incomparableTitle': 'این گروه‌ها با هم قابل مقایسه نیستند',
  'inst.incomparableBody':
    'ابزارها، نسخه‌ها یا جدول‌های هنجاری مختلف، اندازه گیری‌های مختلف اند — بعضی حتی رفتار پرتکرار را در جهت مخالف امتیاز می‌دهند. هر گروه را جداگانه بخوانید.',
  'inst.groupNorm': 'هنجارها: {population}',
  'inst.groupNoNorm': 'بدون جدول هنجاری — فقط امتیازهای خام',
  'inst.groupVersion': 'گروه مقایسه‌پذیری {g}',
  'inst.groupCount': '{n, number} اجرا',
  'inst.colScale': 'مقیاس',
  'inst.seriesRawOnly': 'فقط خام',
  'inst.seriesGap': 'قابل امتیازدهی نیست',

  /* Age-form families (ASQ) */
  'inst.scaleType.domain': 'حوزه‌ها',
  'inst.direction.monitor': 'پایش و غربالگری دوباره',
  'inst.direction.refer': 'ارجاع برای ارزیابی بیشتر',
  'inst.familyForms': '{n} فرم سنی، {from} تا {to}',
  'inst.formLabel': 'فرم سنی',
  'inst.formHelp': 'از سن کودک انتخاب می‌شود؛ اگر لازم بود فرم دیگری انتخاب کنید.',
  'inst.formPick': 'یک فرم انتخاب کنید',
  'inst.formWindow': '{from} تا {to}',
  'inst.pickFormFirst': 'برای ادامه فرم سنی را انتخاب کنید.',
  'inst.ageMd': '{m} ماه {d} روز',
  'inst.ageForForm': 'سن در این تاریخ: {age}',
  'inst.ageAdjusted': 'سن اصلاح\u200cشده برای نارسی: {age}.',
  'inst.formSuggested': 'فرم این سن: {form}.',
  'inst.formNoSuggestion':
    'این سن خارج از بازه هر فرمی است؛ اگر لازم بود خودتان یک فرم انتخاب کنید.',
  'inst.formOverrideTitle': 'فرم انتخاب‌شده با سن کودک نمی‌خواند',
  'inst.formOverrideBody':
    'شما {form} را انتخاب کردید، در حالی که فرم این سن {suggested} است. برش‌های هر فرم به بازه سنی خودش تعلق دارد.',
  'inst.gestationalAge': 'سن بارداری هنگام تولد (هفته)',
  'inst.gestationalAgeHelp':
    'سن فقط وقتی اصلاح می‌شود که کودک پیش از ۳۷ هفته به دنیا آمده و زیر ۲ سال است.',
  'inst.gestationalInvalid': 'عددی بین ۲۰ و ۴۴ وارد کنید، یا خالی بگذارید.',
  'inst.factGestational': 'بارداری',
  'inst.factAdjustedAge': 'سن اصلاح\u200cشده',
  'inst.weeks': '{n} هفته',
  'inst.instructionsTitle': 'نحوه تکمیل',
  'inst.illustration': 'تصویر این گویه',
  'inst.concern': 'این یک نگرانی است',
  'inst.impliedHint':
    'اگر گویه {n} با {options} پاسخ داده شود، این گویه به‌طور خودکار «{answer}» امتیاز می‌خورد.',
  'inst.orJoin': ' یا ',
  'inst.supplementaryStep': 'کلی',
  'inst.supplementarySub':
    'این پرسش‌ها امتیاز نمی‌خورند؛ پاسخ‌هایی که deserve توجه دارند برای درمانگر علامت می‌خورند.',
  'inst.suppYes': 'بله',
  'inst.suppNo': 'خیر',
  'inst.suppExplain': 'توضیح',
  'inst.suppFlag': 'نیازمند توجه',
  'inst.adjustedScore': 'امتیاز اصلاح‌شده: {n} ({k} بی‌پاسخ با میانگین پاسخ جایگزین شد)',
  'inst.flagsTitle': 'نکات قابل توجه',
  'inst.flagsSub':
    'فراتر از امتیازها: پاسخ‌هایی که حتی وقتی امتیازها معمول اند می‌توانند پیگیری یا ارجاع را توجیه کنند.',
  'inst.flagsSupplementary': 'پاسخ‌های قابل توجه در بخش کلی',
  'inst.flagsConcern': 'گویه‌هایی که پاسخ‌دهنده به‌عنوان نگرانی و دغدغه علامت زد',
};
